import React, { useState } from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import JV1 from "../../assets/images/joint.jpeg";


function JointVenture() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    location: "",
    size: "",
    message: "",
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.agree) {
      alert("Please accept the Terms & Conditions");
      return;
    }

    console.log("Joint Venture Form Data:", formData);
    alert("Thank you! Our team will contact you shortly.");
  };

  return (
    <Container className="my-5 joint-venture-page">
        <Row className="text-center mb-5">
            <Col>
              <p className="fw-bold">JOINT VENTURE</p>
              <h3 className="fw-bold font-red">
              Partnering to create sustainable value, trusted growth, and enduring developments
              </h3>        
            </Col>
        </Row>
      {/* ===== Header Section ===== */}
      <Row className="align-items-center mb-5">
        <Col md={6}>
            <div className="heading">
                <p className="text-uppercase fw-bold mt-3">Our Joint Venture</p>

                <h1 className="mb-4 fw-bold font-red">Joint Venture Opportunities</h1>
            </div>
          <p className="text-muted">
            We welcome strategic joint venture partnerships with landowners,
            investors, and property developers. Together, we aim to create
            sustainable, profitable, and long-term value-driven projects.
          </p>
          <p>
            If you own a suitable property or are interested in collaborating
            with us, please share your details below. Our team will evaluate the
            opportunity and get back to you.
          </p>
        </Col>

        <Col md={6}>
          {/* Image Placeholder */}
          <img
            src={JV1}
            alt="Joint Venture"
            className="img-fluid rounded shadow"
          />
        </Col>
      </Row>

      {/* ===== Why Partner With Us ===== */}
      <Row className="mb-5">
        <Col>
          <h3 className="fw-bold text-align-center mb-3">Why Partner With Us?</h3>
          <Row>
            <Col md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5 className="fw-bold text-align-center">Transparent Partnership</h5>
                  <p className="text-muted rrd-para-justify">
                    Clear agreements, ethical business practices, and complete
                    transparency at every stage of the venture.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5 className="fw-bold text-align-center">Strong Market Presence</h5>
                  <p className="text-muted rrd-para-justify">
                    Leverage our brand strength, customer base, and proven
                    operational expertise.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5 className="fw-bold text-align-center">Mutual Growth</h5>
                  <p className="text-muted rrd-para-justify">
                    We believe in win-win partnerships that ensure long-term
                    growth and sustainable returns.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* ===== Joint Venture Form ===== */}
      <Row>
        <Col md={12}>
          <h3 className="fw-semibold mb-3">Joint Venture Enquiry Form</h3>

          <Form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="mobile"
                    placeholder="Enter mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Property Location</Form.Label>
                  <Form.Control
                    type="text"
                    name="location"
                    placeholder="City / Area"
                    value={formData.location}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Property Size</Form.Label>
                  <Form.Control
                    type="text"
                    name="size"
                    placeholder="e.g. 2000 Sq.Ft / Acres"
                    value={formData.size}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                placeholder="Briefly describe your proposal"
                value={formData.message}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Check
                type="checkbox"
                label="I agree to the Terms & Conditions"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
              />
            </Form.Group>

            <button className="btn-jv" type="submit">
              Submit Enquiry
            </button>
          </Form>
        </Col>

        {/* ===== Side Image / Info ===== */}
        {/* <Col md={4}>
          <img
            src={JV2}
            alt="Partnership"
            className="img-fluid rounded shadow mb-3"
          />
          <p className="text-muted">
            Our joint venture team carefully evaluates every proposal to ensure
            alignment with our long-term vision and business values.
          </p>
        </Col> */}
      </Row>
    </Container>
  );
}

export default JointVenture;
